import { PATH_DASHBOARD } from '../../../routes/paths';
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const navConfig = [
  {
    subheader: 'Dealer area',
    items: [
    //  { title: 'Start', path: PATH_DASHBOARD.start, icon: icon('ic_start') },

    //  { title: 'Orders', path: PATH_DASHBOARD.order.pagination, icon: icon('ic_order'), children: [
    //      {title: 'Orders', path: PATH_DASHBOARD.order.pagination, icon: icon('ic_order')},
    //      {title: 'Order archive', path: `${PATH_DASHBOARD.order.pagination}?type=archive`, icon: icon('ic_archive')},
    //  ] },
    ],
  },


];

export default navConfig;
